import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import {
  CREATE_DATED_PLAN_BACK_ACTION,
  CREATE_DATED_PLAN_NEXT_ACTION,
  CREATE_DATED_PLAN_SAVE_ACTION,
  CREATE_TEMPLATE_BACK_ACTION,
  CREATE_TEMPLATE_NEXT_ACTION,
  CREATE_TEMPLATE_SAVE_ACTION,
} from "../../../consts/sentryIds";
import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: "16px",
  },

  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const CreatePlanActions = ({
  isDated,
  step,
  setStep,
  nextDisabled,
  saveDisabled,
  onSave,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        disabled={!!step ? saveDisabled : nextDisabled}
        onClick={() => (!!step ? onSave() : setStep(1))}
        sentryId={
          isDated
            ? !step
              ? CREATE_DATED_PLAN_NEXT_ACTION
              : CREATE_DATED_PLAN_SAVE_ACTION
            : !step
            ? CREATE_TEMPLATE_NEXT_ACTION
            : CREATE_TEMPLATE_SAVE_ACTION
        }
      >
        {!!step ? "Save Plan" : "Next"}
      </Button>
      {!!step && (
        <Button
          className={styles.yellow}
          variant={"contained"}
          onClick={() => setStep(0)}
          sentryId={
            isDated
              ? CREATE_DATED_PLAN_BACK_ACTION
              : CREATE_TEMPLATE_BACK_ACTION
          }
        >
          Back
        </Button>
      )}
    </View>
  );
};
